export const ps = {
   cal: {
      label: 'cal',
      marker: 1,
      borderColor:'white',
      borderWidth: 0.5,
      faceColor:'#B0A8A0',
      lineColor:'#B0A8A0',
      lineWidth: 1.0
   },
   pv: {
      label: 'cal',
      marker: 1,
      borderColor:'#2679B2',
      borderWidth: 1.5,
      faceColor:'transparent',
      lineColor:'#2679B2',
      lineWidth: 1.25
   },
}